export default "__VITE_ASSET__D3I7v3iI__"